<template>
  <div class="progress-normal-bar" 
       ref="progress_bar_ref"
       @touchstart="onTouchProgressEvent($event)"
       @touchmove="onTouchProgressEvent($event)"
       @touchend="onTouchProgressEvent($event)">
    <dl :class="`progress-show-style-${showType}`">
      <dt>
        <span ref="current_progress_ref" class="progress-box"></span>
      </dt>
      <dd ref="drag_button_ref" class="drag-button-box"></dd>
    </dl>
  </div>
</template>

<script>
/**
 引用： const normalProgressBar = require('@/pages/components/video_player/child/progress_normal_bar');
 <normal-progress-bar showType="miniDrag"
                      @touchInfo="getProgressData"/>
 
 */

// 函数方法 start
import { AsyncFunc } from '@/utils/utils';
// 函数方法 end
export default {
  props: {
    showType: [String],
    initStyle: [Boolean],
    progressPoint: [Number,String],
    bannedControl: [Boolean],
  },
  components: {

  },
  data(){
    return {
      progressBarDom: null,
      currentProgressDom: null,
      dragDom: null,
      progressBarWith: 0,
      progressBarLeft: 0,
      dragDomWidth: 0,
      touchProgressStatus: false,
    }
  },
  watch: {
    progressPoint: function() {
      this.updateProgressBarData();
      this.setShowProgressByPoint(this.progressPoint);
    },
  },
  mounted() {
    this.setProgressDomData();
  },
  methods: {
    setProgressDomData: function() {
      this.progressBoxDom = this.$refs.progress_bar_ref;
      this.currentProgressDom = this.$refs.current_progress_ref;
      this.dragDom = this.$refs.drag_button_ref;
  
      if (!this.progressBoxDom || !this.currentProgressDom || !this.dragDom) {
        setTimeout(()=>{
          this.setProgressDomData();
        },100)

        return;
      }

      this.setProgressDomInfo();
    },
    setProgressDomInfo: function() {
      const barOffset = $(this.progressBoxDom).offset();

      this.progressBarWith = $(this.progressBoxDom).width();
      this.progressBarLeft = barOffset.left;
      this.dragDomWidth = $(this.dragDom).width();
    },
    onTouchProgressEvent: function(touchData) {
      if (this.bannedControl) {
        return;
      }

      const touchType = touchData.type;
      const changedTouches = touchData.changedTouches;
      const touchY = changedTouches && changedTouches[0] ? changedTouches[0].clientX : 0;
      
      switch (touchType) {
        case 'touchstart':
          this.touchProgressStatus = true;
          this.setProgressDomInfo();
        break;
        case 'touchmove':
          this.touchProgressStatus = true;
        break;
        case 'touchend':
          this.touchProgressStatus = false;
        break;
      }

      this.setProgressShowStyleByTouchNumber(touchType,touchY);
    },
    updateProgressBarData: function() {
      const progressWidth = $(this.progressBoxDom).width();
      
      if (progressWidth == this.progressBarWith) {
        return;
      }

      this.setProgressDomInfo();
    },
    getTouchNumber: function(touchY) {
      let moveY = 0;
      let startY = 0;
      let endY = 0;

      startY = touchY - this.progressBarLeft;
      endY = this.progressBarWith;

      startY = startY < 0 ? 0 : startY;
      moveY = startY > endY ? endY: startY;

      return moveY;
    },
    setProgressShowStyleByTouchNumber: function(touchType,moveNum) {
      const setMoveY = this.getTouchNumber(moveNum);

      this.sendProgressInfo(touchType,setMoveY);
      this.setProgressShowStyleByMoveNum(setMoveY);
    },
    setProgressShowStyleByMoveNum: function(moveNum) {
      this.setProgressWidthByMoveNum(moveNum);
      this.setDragLeftByMoveNum(moveNum);
    },
    setShowProgressByPoint: function(point) {
      if (this.touchProgressStatus) {
        return;
      }
      
      const setPoint = parseFloat(point);
      const moveNum = Math.round(this.progressBarWith * setPoint);
      
      this.setProgressShowStyleByMoveNum(moveNum);
    },
    // 设置播放进度 start
    getCurrentProgressWidthByMoveNumber: function(moveNum) {
      return moveNum;
    },
    setProgressWidthByMoveNum: function(moveNum) {
      const setWidth = this.getCurrentProgressWidthByMoveNumber(moveNum);
      this.setProgressShoWWidth(setWidth);
    },
    setProgressShoWWidth: function(widthNum) {
      $(this.currentProgressDom).css({
        width: `${widthNum}px`
      })
    },
    // 设置播放进度 end 
    // 设置拖拽按钮 start
    getDragLeftByMoveNumber: function(moveNum) {
      let halfWidth = this.dragDomWidth / 2;
      let setMove = moveNum - halfWidth;
      let maxMove = this.progressBarWith - this.dragDomWidth;

      setMove = setMove <=0 ? 0 : setMove;
      setMove = setMove >= maxMove ? maxMove : setMove;

      return setMove;
    },
    setDragLeftByMoveNum: function(moveNum) {
      const setLeft = this.getDragLeftByMoveNumber(moveNum);
      this.setDragShowLeft(setLeft);
    },
    setDragShowLeft: function(leftNum) {
      $(this.dragDom).css({
        left: `${leftNum}px`
      })
    },
    // 设置拖拽按钮 end
    getPointByTouchY: function(touchY) {
      const totalNum = this.progressBarWith - this.dragDomWidth;
      let setNum = (touchY / totalNum).toFixed(2);
      
      setNum = setNum <= 0 ? 0 : setNum;
      setNum = setNum >= 1 ? 1 : setNum;

      return parseFloat(setNum);
    },
    sendProgressInfo: function(touchType,moveY) {
      const point = this.getPointByTouchY(moveY);
    
      AsyncFunc(this.sendTouchInfo,100)({
        buttonType: 'progressBar',
        type: touchType,
        point: point
      })
    },
    sendTouchInfo: function(touchInfo) {
      this.$emit('touchInfo',touchInfo);
    },
  },
};
</script>

<style lang="less">
  .progress-normal-bar {
    width: 100%;
    &>dl {
      width: 100%;
      &>dt {
        overflow: hidden;
        width: 100%;
        height: 4px;
        border-radius: 4px;
        background: rgba(255,255,255,0.4);
        // 位置控制 start
        float: left;
        position: relative;
        top: calc(0.16rem / 2 - 2px);
        &>span {
          display: block;
          width: 0;
          height: 100%;
          background: #fff;
        }
      }
      &>dd {
        position: relative;
        width: 0.16rem;
        height: 0.16rem;
        border-radius: 0.16rem;
        background: #fff;
      }
    }
    &>.progress-show-style-miniDrag {
      padding-top: 0.05rem;
      padding-bottom: 0.05rem;
      &>dt {
        top: calc(0.08rem / 2 - 2px);
        background: #333;
        opacity: 0.5;
      }
      &>dd {
        width: 0.08rem;
        height: 0.08rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/video_player/child/progress_normal_bar.vue